import { HttpClient } from '@shared/adapters/HttpClient';

export interface PaymentMethodErrorRequest {
  payment_method_id: number;
}

export interface PaymentMethodErrorResponse {
  success: boolean;
  message: string;
}

export class PaymentMethodErrorApiAdapter {
  constructor(private httpClient: HttpClient) {}

  async solvePaymentMethodError(
    orderId: number,
    data: PaymentMethodErrorRequest
  ): Promise<PaymentMethodErrorResponse> {
    try {
      console.log(
        '🔍 PaymentMethodErrorApiAdapter - Solving payment method error:',
        {
          orderId,
          data,
        }
      );

      const response = await this.httpClient.put(
        `/orders/${orderId}/solve-error/payment-method`,
        data
      );

      console.log('🔍 PaymentMethodErrorApiAdapter - Response:', response);

      return {
        success: true,
        message: response.message || 'Método de pago actualizado correctamente',
      };
    } catch (error: any) {
      console.log('🔍 PaymentMethodErrorApiAdapter - Error:', error);
      throw error;
    }
  }
}
